import * as React from 'react'
import { Box, Grid } from '@design/pt-ui'

interface IInfoPage {
  title: string
  heading?: string
  description: string
}

function InfoPage(props: IInfoPage) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        height: '100%',
        alignItems: 'center',
      }}>
      <Grid container={true} spacing={3} sx={{ width: '100%' }}>
        <Grid
          sx={{
            display: 'flex',
            flexFlow: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          size={{
            md: 12,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              marginRight: '25px',
            }}>
            <Box
              component="h1"
              sx={{
                fontSize: 100,
                color: 'custom.gray.light',
                marginBottom: 0,
              }}>
              {props.title}
            </Box>
            {props.heading ? (
              <Box
                component="p"
                sx={{
                  fontSize: 26,
                  marginBottom: '10px',
                  marginTop: '5px',
                  color: 'secondary.main',
                }}>
                {props.heading}
              </Box>
            ) : null}
            <Box component="span" sx={{ color: '#a49b9b' }}>
              {props.description}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default InfoPage
